import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const GroupsPage = lazy(() => import('@cobliteam/groups/src/pages/GroupsPage'));

const routes = [
  {
    exact: true,
    path: Location.VEHICLES_GROUPS,
    team: 'squad-account-experience',
    component: GroupsPage,
  },
  {
    exact: true,
    path: Location.VEHICLES_GROUPS_ID,
    team: 'squad-account-experience',
    component: GroupsPage,
  },
];

export default routes;
